import Icon from '../components/Icon.vue'

Icon.register({"phone":{"width":512,"height":512,"paths":[{"d":"M493.4 24.6L389.4 0.6C378.1-2 366.5 3.9 361.9 14.5L313.9 126.5C309.7 136.3 312.5 147.8 320.8 154.5L381.4 204.1C345.4 280.8 282.5 344.6 204.2 381.3L154.6 320.7C147.8 312.4 136.4 309.6 126.6 313.8L14.6 361.8C3.9 366.5-2 378.1 0.6 389.4L24.6 493.4C27.1 504.2 36.7 512 48 512 304.1 512 512 304.5 512 48 512 36.8 504.3 27.1 493.4 24.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/phone.js
// module id = 73Iz
// module chunks = 0